import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalBody, ModalFooter, ModalHeader, Button} from "reactstrap"
import Promise from "bluebird";
import {updateBarcode} from '../../../services/api/apiBarcode'
import {pushNewItemHistory} from "../../../services/api/apiItemHistory";

class DeleteLabelModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            listItems: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: ''
        }
    }

    componentDidMount = async () => {
        await this._getListItems()
        await this._delAllBarcode()
    }

    _getListItems = () => {
        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))

        this.setState({
            listItems
        })
    }

    _delAllBarcode = () => {
        const {listItems} = this.state

        this._delBarcode(listItems)
    }

    _delBarcode = async (listItems) => {
        const total = this.state.itemsSuccess.length > 0 ? (listItems.length + this.state.itemsSuccess.length) : listItems.length

        await Promise.each(listItems, async item => {
            this.setState({
                itemLoading: item._id
            })

            const {labelDetails} = item

            if (labelDetails === null || typeof labelDetails === undefined) {
                let {itemError, itemsSuccess} = this.state
                itemError.push({
                    _id: item._id,
                    labelDetails: labelDetails,
                    canDelete: false,
                    message: "Item not have label"
                })

                return this.setState({
                    itemError: itemError,
                    itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                })
            } else {
                try {
                    const {data} = await updateBarcode(item._id, {labelDetails: null})

                    const {success, message} = data

                    let {itemError, itemsSuccess} = this.state

                    if (success) {
                        itemsSuccess.push(item._id)
                        this.setState({
                            itemsSuccess: itemsSuccess,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        }, () => {
                            return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                                event_key: 'delete_label',
                                event_description: `Delete bulk action label`,
                                event_meta: {
                                    source: 'bulk_delete_label',
                                }
                            })
                        })
                    } else {
                        itemError.push({
                            _id: item._id,
                            message: message
                        })

                        this.setState({
                            itemError: itemError,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        })
                    }
                } catch (e) {
                    let {itemError, itemsSuccess} = this.state

                    this.setState({
                        itemError: e.message,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }
            }
        })
    }

    _delItemBarcode = async (orderID) => {

        try {
            const {itemsSuccess, itemError} = this.state
            const {success, message} = await updateBarcode(orderID, {labelDetails: null})

            if (success) {
                itemsSuccess.push(orderID)

                this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: ''
                })
            } else {
                const newItemErr = itemError.map(item => {
                    if (item._id === orderID) {
                        return {
                            ...item,
                            message: message
                        }
                    }
                    return item
                })

                this.setState({
                    itemError: newItemErr,
                    itemLoading: ''
                })
            }
        } catch (e) {
            this.setState({
                itemError: e.message,
                itemLoading: ''
            })
        }
    }

    _handleClickRetryItem = async (orderID) => {
        const {itemError} = this.state
        const newItemsStatus = itemError.map(item => {
            return item._id === orderID ? {
                ...item,
                message: ''
            } : item
        })

        this.setState({
            itemError: newItemsStatus,
            itemLoading: orderID
        })

        this._delItemBarcode(orderID)
    }

    _retryAll = () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        this._delBarcode(itemError)
    }

    _showMessage = (itemError, itemsSuccess, item) => {
        if (itemError.find(itemErr => item === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => item === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => item === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(item)) {
            return (
                <span className="d-sm-block text-success">Delete label success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    _closePopup = () => {
        const {resetBulkAll, reloadItems, handleToggleModal} = this.props

        handleToggleModal()
        resetBulkAll()
        reloadItems()
    }

    render() {
        const {isOpen} = this.props
        const {listItems, itemLoading, itemsSuccess, itemError} = this.state
        const newItems = itemError.filter(item => item.hasOwnProperty('canDelete'))

        return (
            <div className="DeleteLabelModal">
                <Modal isOpen={isOpen} className="BulkGenLabels">
                    <ModalHeader>Delete label</ModalHeader>
                    <ModalBody>
                        <div className="ListGenLabels">
                            {
                                listItems.length > 0 && listItems.map(item => {
                                    return (
                                        <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                            <div className="IconStatus mr-2">
                                                {itemsSuccess.includes(item._id) && (
                                                    <i className="icon-check text-success"/>
                                                )}
                                                {
                                                    (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                        <i className="icon-cross text-danger"/>
                                                    )
                                                }
                                            </div>
                                            <div className="ContentGenLabel">
                                                <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                {
                                                    (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id && item.canDelete) && (
                                                        <span onClick={() => this._handleClickRetryItem(item)}>
                                                            <i className="icon-spinner11 text-danger ml-2"/>
                                                        </span>
                                                    )
                                                }
                                                {itemLoading === item._id &&
                                                <i className='icon-spinner2 spinner ml-2'/>}
                                                {this._showMessage(itemError, itemsSuccess, item._id)}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            {(itemError.length > 0 && newItems.length === 0) && (
                                <Button onClick={this._retryAll} className="bg-danger"><i
                                    className="icon-spinner11 mr-1"/> Retry all</Button>
                            )}
                            <Button disabled={itemLoading !== ''} onClick={this._closePopup}
                                    className="bg-primary ml-2">
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

DeleteLabelModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleToggleModal: PropTypes.func.isRequired
}

export default DeleteLabelModal
